module.exports = {"370672003":"古现街道（烟台开发区）","370672004":"大季家街道（烟台开发区）","370672005":"八角街道（烟台开发区）","370672008":"福莱山街道（烟台开发区）"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370672.json
// module id = 1404
// module chunks = 0